import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import toast from 'react-hot-toast';
import { getErrorString } from '../../utils';
import { fetchExportsApi } from '../../api/exports-api';
import { getQueryString } from '../../utils/filters-util';
import { setQuickLinks } from 'reducers/quick-links-slice';

const initialState = {
  activeColumns: [],
  exports: [],
  loading: true,
  pending: false,
  pagination: {},
};

export const fetchExportsListing = createAsyncThunk('exports/listing', async (updatedParamsObject = {}, { dispatch }) => {
  try {
    const paramsObj = {
      'q[s]': 'created_at desc',
      ...updatedParamsObject,
    };
    const res = await fetchExportsApi({}, getQueryString(paramsObj));
    if (res?.status) {
      dispatch(setQuickLinks(res?.user_filters));
    }
    return res;
  } catch (error) {
    toast.error(getErrorString(error));
  }
});

const ExportsSlice = createSlice({
  name: 'exports',
  initialState,
  reducers: {
    setExportsLoading: (state, action) => {
      state.loading = action?.payload?.loading;
    },
    setExportsActiveColumn: (state, action) => {
      state.activeColumns = action?.payload?.activeColumns;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchExportsListing.pending, (state) => {
        state.pending = true;
      })
      .addCase(fetchExportsListing.fulfilled, (state, action) => {
        if (state.loading) {
          state.activeColumns = action?.payload?.active_columns || [];
        }
        state.exports = action?.payload?.data || [];
        state.loading = false;
        state.pending = false;
        state.pagination = action?.payload?.meta?.pagination || {};
      })
      .addCase(fetchExportsListing.rejected, (state) => {
        state.loading = false;
        state.pending = false;
      });
  },
});

export const { setExportsLoading, setExportsActiveColumn } = ExportsSlice.actions;
export default ExportsSlice.reducer;
